import { AngularEditorConfig } from '@kolkov/angular-editor';

export const WYSIWYG_CONFIG: AngularEditorConfig = {
  defaultParagraphSeparator: 'br',
  height: '200px',
  maxHeight: '200px',
  sanitize: true,
  toolbarHiddenButtons: [
    [
      'undo',
      'redo',
      'subscript',
      'superscript',
      'indent',
      'outdent',
      'insertUnorderedList',
      'insertOrderedList',
      'heading',
      'fontName',
      'justifyLeft',
      'justifyCenter',
      'justifyRight',
      'justifyFull',
    ],
    [
      'fontSize',
      'textColor',
      'backgroundColor',
      'customClasses',
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
    ],
  ],
};
